import React, { useEffect } from "react";
import Select from "react-select";
import { Form } from "react-bootstrap";
import { FieldProps } from "formik";
import SelectOption from "./helpers/SelectOption";

import FormikFieldCustomProps from "./helpers/FormikFieldCustomProps";

const ReactPresentationSelect: React.FC<FormikFieldCustomProps & FieldProps & {handleChange?: (value: any) => {}}> = ({
  field: { value, ...field }, // { name, value, onChange, onBlur }
  form: { touched, errors, setFieldValue },
  onChange,
  ...props
}) => {

  useEffect(() => {
    if(onChange) {
      onChange()
    }
  }, [value, onChange]);

  let error = errors[field.name];
  let touch = touched[field.name];
  const getValue = () => {
    if (props.options) {
      return props.isMulti
        ? props.options.filter(
            (option: any) => value.indexOf(option.value) >= 0
          )
        : props.options.find((option: any) => option.value === value);
    } else {
      return props.isMulti ? [] : ("" as any);
    }
  };
  // let sortedOptions = props.options
  //   ? props.options //.sort((a: SelectOption, b: SelectOption) => a.label.localeCompare(b.label))
  //   : [];
  return (
    <Form.Group controlId={field.name}>
      <Select
        {...field}
        {...props}
        name={field.name}
        value={getValue()}
        joinValues={true}
        onChange={(selectedOptions: any) => {
          if (selectedOptions) {
            setFieldValue(
              field.name,
              props.isMulti
                ? (selectedOptions as SelectOption[]).map(
                    (item: SelectOption) => item.value
                  )
                : (selectedOptions as SelectOption).value
            );
          } else {
            setFieldValue(field.name, props.isMulti ? [] : "");
          }
          if (props.handleChange) {
            props.handleChange((selectedOptions as SelectOption).value);
          }
        }}
        invalid={Boolean(touched[field.name] && errors[field.name])}
        closeMenuOnSelect={props.isMulti ? false : true}
        className="react-select-container"
        classNamePrefix="react-select"
        error={touch && error && <Form.Text>{error}</Form.Text>}
        options={props.options}
      />
      {error && <div className="invalid-feedback">{error}</div>}
    </Form.Group>
  );
};

export default ReactPresentationSelect;
